import { ActionStatus } from 'interfaces/journey';
import type { TableCollection } from './CollectionsTable';

const COLLECTION_STATUS_LABEL: Record<string, string> = {
  requested: 'Solicitada',
  received: 'Ingresada',
  not_collected: 'No colectada',
  cancelled: 'Cancelada',
  arrived: 'En el lugar',
  routed: 'Pendiente',
};

const COLLECTED = ['collected', 'ingesting', 'received'];

export const isTransferred = (row: TableCollection): boolean =>
  row.actionStatus === ActionStatus.Transferred ||
  row.deliveryStatus === ActionStatus.Transferred;

// Si la parada misma pasó a otra ruta, no la retiró esta, aunque ms-collections ya la vea retirada.
const transferredLabel = (row: TableCollection): string =>
  row.actionStatus === ActionStatus.Completed ||
  (row.actionStatus !== ActionStatus.Transferred &&
    COLLECTED.includes(row.collectionStatus ?? ''))
    ? 'Colectada'
    : 'Transferida';

export const statusLabel = (row: TableCollection): string => {
  const { collectionStatus } = row;
  if (isTransferred(row)) return transferredLabel(row);
  if (collectionStatus === 'collected' || collectionStatus === 'ingesting')
    return row.deliveryStatus === ActionStatus.Completed
      ? 'Ingresada'
      : 'Colectada · sin ingresar';
  if (collectionStatus && COLLECTION_STATUS_LABEL[collectionStatus])
    return COLLECTION_STATUS_LABEL[collectionStatus];
  if (row.actionStatus === ActionStatus.Canceled) return 'Cancelada';
  if (row.actionStatus === ActionStatus.Completed)
    return row.deliveryStatus === ActionStatus.Completed
      ? 'Ingresada'
      : 'Colectada';
  if (
    row.actionStatus === ActionStatus.Failed ||
    row.actionStatus === ActionStatus.Forced_end
  )
    return 'No colectada';
  return row.arrivedAt ? 'En el lugar' : 'Pendiente';
};

// Ingresada en el depósito: lo dice ms-collections o, sin ese dato, la entrega en el centro.
export const isIngested = (row: TableCollection): boolean =>
  row.collectionStatus === 'received' ||
  row.deliveryStatus === ActionStatus.Completed;
